import { Preferences } from '@capacitor/preferences';
import { GolfClub } from '@/pages/ClubsExplorer';

// Extended type to include visit date
export interface RecentGolfClub extends GolfClub {
  visitedAt?: string; // ISO date string
}

// Storage key for recently visited clubs
export const RECENT_CLUBS_STORAGE_KEY = 'recentlyVisitedClubs';

// Maximum number of recently visited clubs to store
export const MAX_RECENT_CLUBS = 8;

/**
 * Save a club to recently visited clubs in localStorage
 */
export const saveVisitedClub = async (club: GolfClub) => {
  try {
    // Get existing clubs
    const { value } = await Preferences.get({ key: RECENT_CLUBS_STORAGE_KEY });
    let recentClubs: RecentGolfClub[] = value ? JSON.parse(value) : [];
    
    // Remove the club if it already exists to avoid duplicates
    recentClubs = recentClubs.filter(c => c.id !== club.id);
    
    // Add the club to the beginning of the array with current date
    const recentClub: RecentGolfClub = {
      ...club,
      visitedAt: new Date().toISOString()
    };
    
    recentClubs.unshift(recentClub);
    
    // Limit to MAX_RECENT_CLUBS
    if (recentClubs.length > MAX_RECENT_CLUBS) {
      recentClubs = recentClubs.slice(0, MAX_RECENT_CLUBS);
    }
    
    // Save back to storage
    await Preferences.set({
      key: RECENT_CLUBS_STORAGE_KEY,
      value: JSON.stringify(recentClubs)
    });
  } catch (error) {
    console.error('Error saving visited club:', error);
  }
};

/**
 * Get recently visited clubs from localStorage
 */
export const getRecentlyVisitedClubs = async (): Promise<RecentGolfClub[]> => {
  try {
    const { value } = await Preferences.get({ key: RECENT_CLUBS_STORAGE_KEY });
    return value ? JSON.parse(value) : [];
  } catch (error) {
    console.error('Error getting recently visited clubs:', error);
    return [];
  }
};
